import _ from "lodash"
import { dateFormatter } from "../components/AgGrid/grid-util"
import TickerHyperLinkComponent from "../components/TickerHyperLinkComponent"
import { dateFormat, gridCentsPerShareFormatter, myValueFormatter, rateFormatter } from "./commonFunctions"
import { dtcStatusColors, TradeStatus } from "./constants"

export const ratesDashboardColDef = [
  {
    headerName: 'Date',
    field: 'price_date',
    editable: false,
    floatingFilter: false,
    floatingFilterComponentParams: { suppressFilterButton: true },
    cellStyle: {
      display: 'flex',
      alignItems: 'center',
      borderRight: '0.5px solid #E1E1E1'
    },
    minWidth: 130,
    maxWidth: 150,
    valueFormatter: dateFormat,
    filterParams: {
      valueFormatter: dateFormat
    },
    suppressSizeToFit: false,
    filter: 'agSetColumnFilter',
    sortable: true
  },
    {
      headerName: 'Ticker',
      field: 'ticker',
      floatingFilter: false,
      editable: function (params: any) {
        if (params.node.data.isNewRowInsert) {
          return true
        } else {
          return false
        }
      },
      filter: 'agMultiColumnFilter',
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: (params: any) => {
        if (params?.node?.data?.isTickerUpdated) {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            backgroundColor: dtcStatusColors.pended
          }
        } else {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1'
          }
        }
      },
      minWidth: 80,
      maxWidth: 130,
      suppressSizeToFit: false,
      sortable: true,
      cellRenderer: TickerHyperLinkComponent
    },
    {
      headerName: 'Cusip',
      field: 'cusip',
      floatingFilter: false,
      editable: false,
      filter: 'agMultiColumnFilter',
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '0.5px solid #E1E1E1'
      },
      minWidth: 100,
      maxWidth: 180,
      suppressSizeToFit: false,
      filterParams: {
        allowedCharPattern: '\\d\\-\\,',
        numberParser: (text: any) => {
          return parseFloat(text.replace(',', ''))
        }
      },
      sortable: true
    },
    {
      headerName: 'Price',
      field: 'price_market',
      editable: false,
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      type: 'rightAligned',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderRight: '0.5px solid #E1E1E1'
      },
      valueFormatter: myValueFormatter,
      minWidth: 120,
      maxWidth: 150,
      filter: 'agMultiColumnFilter',
      sortable: true
    },
    {
      headerName: 'Name',
      field: 'name',
      editable: false,
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '0.5px solid #E1E1E1'
      },
      minWidth: 200,
      maxWidth: 250,
      filter: 'agMultiColumnFilter',
      sortable: true
    },
   
    {
      headerName: 'Isin',
      field: 'isin',
      editable: false,
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '0.5px solid #E1E1E1'
      },
      minWidth: 130,
      maxWidth: 150,
      suppressSizeToFit: false,
      filter: 'agMultiColumnFilter',
      sortable: true
    },
    {
      headerName: 'LP out',
      field: 'lp_rate_out',
      editable: false,
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      minWidth: 130,
      maxWidth: 150,
      type: 'rightAligned',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderRight: '0.5px solid #E1E1E1'
      },
      suppressSizeToFit: false,
      filter: 'agMultiColumnFilter',
      sortable: true
    },
    {
      headerName: 'LP new',
      field: 'lp_rate_new',
      editable: false,
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      type: 'rightAligned',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderRight: '0.5px solid #E1E1E1'
      },
      minWidth: 130,
      maxWidth: 150,
      suppressSizeToFit: false,
      filter: 'agMultiColumnFilter',
      sortable: true
    },
    {
      headerName: 'LP last',
      field: 'lp_last_avg',
      editable: false,
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      type: 'rightAligned',
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        borderRight: '0.5px solid #E1E1E1'
      },
      minWidth: 130,
      maxWidth: 150,
      suppressSizeToFit: false,
      filter: 'agMultiColumnFilter',
      sortable: true
    },
    {
      headerName: 'Spread',
      field: 'spread',
      floatingFilter: false,
      editable: true,
      floatingFilterComponentParams: { suppressFilterButton: true },
      type: 'rightAligned',
      cellStyle: (params: any) => {
        if (params?.node?.data?.isRowUpdated && params?.node?.data?.isSpreadUpdated && (isNaN(params?.node?.data?.spread))) {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            backgroundColor: TradeStatus.error,
            justifyContent: 'right'
          }
        }
       else if (params?.node?.data?.isRowUpdated && params?.node?.data?.isSpreadUpdated) {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            backgroundColor: dtcStatusColors.pended,
            justifyContent: 'right'
          }
        } else {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            justifyContent: 'right'
          }
        }
      },
      minWidth: 160,
      maxWidth: 180,
      suppressSizeToFit: false,
      filter: 'agMultiColumnFilter',
      sortable: true
    },
    {
      headerName: 'Cents Spread',
      field: 'cents_spread',
      editable: true,
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      type: 'rightAligned',
      cellDataType:'text',
      cellStyle: (params: any) => {
        if (params?.node?.data?.isRowUpdated && params?.node?.data?.isCentsSpreadUpdated && isNaN(params?.node?.data?.cents_spread)) {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            backgroundColor: TradeStatus.error,
            justifyContent: 'right'
          }
        }
       else if (params?.node?.data?.isRowUpdated && params?.node?.data?.isCentsSpreadUpdated) {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            backgroundColor: dtcStatusColors.pended,
            justifyContent: 'right'
          }
        } else {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            justifyContent: 'right'
          }
        }
      },
      minWidth: 130,
      maxWidth: 150,
      suppressSizeToFit: false,
      filter: 'agMultiColumnFilter',
      sortable: true
    },
    {
      headerName: 'Borrow Rate',
      field: 'ss_br_rate',
      editable: true,
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      type: 'rightAligned',
      cellStyle: (params: any) => {
        if (params?.node?.data?.isRowUpdated && params?.node?.data?.isBorrowRateUpdated && !(/^-?(\d{1,3}|\d{1,3}\.\d{1,4})$/.test(params?.node?.data?.ss_br_rate))) {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            backgroundColor: TradeStatus.error,
            justifyContent: 'right'
          }
        }
        else if (params?.node?.data?.isRowUpdated && params?.node?.data?.isBorrowRateUpdated) {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            backgroundColor: dtcStatusColors.pended,
            justifyContent: 'right'
          }
        } else {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            justifyContent: 'right'
          }
        }
      },
      minWidth: 130,
      maxWidth: 150,
      suppressSizeToFit: false,
      filter: 'agMultiColumnFilter',
      sortable: true,
      valueFormatter: rateFormatter
    },
    {
      headerName: 'Loan Rate',
      field: 'ss_ln_rate',
      editable: true,
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      minWidth: 130,
      maxWidth: 150,
      type: 'rightAligned',
      cellStyle: (params: any) => {
        if (params?.node?.data?.isRowUpdated && params?.node?.data?.isLoanRateUpdated && !(/^-?(\d{1,3}|\d{1,3}\.\d{1,4})$/.test(params?.node?.data?.ss_ln_rate))) {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            backgroundColor: TradeStatus.error,
            justifyContent: 'right'
          }
        }
        else if (params?.node?.data?.isRowUpdated && params?.node?.data?.isLoanRateUpdated) {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            backgroundColor: dtcStatusColors.pended,
            justifyContent: 'right'
          }
        } else {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            justifyContent: 'right'
          }
        }
      },
      suppressSizeToFit: false,
      filter: 'agMultiColumnFilter',
      sortable: true,
      valueFormatter: rateFormatter
    },
    {
      headerName: 'Locate Rate',
      field: 'ss_locate_rate',
      editable: true,
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      type: 'rightAligned',
      cellStyle: (params: any) => {
        if (params?.node?.data?.isRowUpdated && params?.node?.data?.isLocateRateUpdated && !(/^-?(\d{1,3}|\d{1,3}\.\d{1,4})$/.test(params?.node?.data?.ss_locate_rate))) {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            backgroundColor: TradeStatus.error,
            justifyContent: 'right'
          }
        }
        if (params?.node?.data?.isRowUpdated && params?.node?.data?.isLocateRateUpdated) {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            backgroundColor: dtcStatusColors.pended,
            justifyContent: 'right'
          }
        } else {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            justifyContent: 'right'
          }
        }
      },
      minWidth: 130,
      maxWidth: 150,
      suppressSizeToFit: false,
      filter: 'agMultiColumnFilter',
      sortable: true,
      valueFormatter: rateFormatter
    },
    {
      headerName: 'Cents per Share',
      field: 'cents_share',
      editable: true,
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      type: 'rightAligned',
      cellStyle: (params: any) => {
        if (params?.node?.data?.isRowUpdated && params?.node?.data?.isCentsPerShareUpdated && !(!isNaN(params?.node?.data?.cents_share) && /^\d+(\.\d+)?$/.test(params?.node?.data?.cents_share))) {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            backgroundColor: TradeStatus.error,
            justifyContent: 'right'
          }
        }
        else if (params?.node?.data?.isRowUpdated && params?.node?.data?.isCentsPerShareUpdated) {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            backgroundColor: dtcStatusColors.pended,
            justifyContent: 'right'
          }
        } else {
          return {
            display: 'flex',
            alignItems: 'center',
            borderRight: '0.5px solid #E1E1E1',
            justifyContent: 'right'
          }
        }
      },
      minWidth: 170,
      maxWidth: 190,
      suppressSizeToFit: false,
      filter: 'agMultiColumnFilter',
      valueFormatter: gridCentsPerShareFormatter,
      sortable: true
    },
    {
      headerName: 'Updated Time',
      field: 'current_timestamp',
      editable: false,
      valueFormatter: dateFormatter,
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '0.5px solid #E1E1E1'
      },
      minWidth: 250,
      maxWidth: 250,
      suppressSizeToFit: false,
      filter: 'agMultiColumnFilter',
      sortable: true
    },
    {
      headerName: 'Comments',
      field: 'comments',
      editable: false,
      floatingFilter: false,
      floatingFilterComponentParams: { suppressFilterButton: true },
      cellStyle: {
        display: 'flex',
        alignItems: 'center',
        borderRight: '0.5px solid #E1E1E1'
      },
      minWidth: 250,
      maxWidth: 250,
      suppressSizeToFit: false,
      filter: 'agMultiColumnFilter',
      sortable: true
    }
  ]